import { setProps } from '../props';
import initialize from '../Services/initialize';

export default (props) => async (dispatch) => {

  setProps(props);

  dispatch(initialize());
  
}